<template>
  <h2>{{ t('account.title') }}</h2>
  <Tabs v-model:value="activeTab">
    <TabList>
      <Tab :value="0">
        {{ t('account.profile_section') }}
      </Tab>
      <Tab :value="1">
        {{ t('account.api_keys_section') }}
      </Tab>
      <Tab :value="2">
        {{ t('account.security_section') }}
      </Tab>
    </TabList>
    <TabPanels>
      <TabPanel :value="0">
        <ProfileInfo
          :account="account"
          :account-services="account_services"
          :r7e-app="r7eBaseApp"
          v-if="account"
        />
        <p v-else>
          {{ t('account.loading') }}
        </p>
      </TabPanel>
      <TabPanel :value="1">
        <ProfileApiKeys />
      </TabPanel>
      <TabPanel :value="2">
        <SecuritySettings />
      </TabPanel>
    </TabPanels>
  </Tabs>
</template>

<script setup>
import { ref, onMounted } from 'vue';
import { r7eBaseApp } from '../services/index.js';
import { ProfileInfo, ProfileApiKeys, SecuritySettings } from '../components/index.js';
import { useI18n } from 'vue-i18n';
import Tabs from 'primevue/tabs';
import TabList from 'primevue/tablist';
import Tab from 'primevue/tab';
import TabPanels from 'primevue/tabpanels';
import TabPanel from 'primevue/tabpanel';
const { t } = useI18n();
const account = ref(null);
const account_services = ref([]);
const activeTab = ref(0);

const fetchAccount = async () => {
  // console.log('fetchAccount', r7eBaseApp.baseAppType);
  try {
    await r7eBaseApp.refreshAccount();
    account.value = await r7eBaseApp.getAccount();
    // console.log('fetchAccount', account.value);
    account_services.value = r7eBaseApp.getRoles() || [];
  } catch (e) {
    account.value = null;
    account_services.value = [];
  }
};


onMounted(async () => {
  await fetchAccount();
});

</script>

<style scoped>
.info-card {
  background-color: var(--color-frame-bg);
  border: 1px solid var(--color-border);
  padding: 20px;
  border-radius: 5px;
}
.info-card p {
  margin: 10px 0;
  font-size: 1.1em;
}
.info-card strong {
  color: var(--color-safe);
}
.account-container {
  /* max-width: 600px; */
  margin: 1rem auto;
  padding: 1rem;
  background: var(--color-frame-bg);
  border-radius: 8px;
  box-shadow: 0 4px 12px rgba(0,0,0,0.10);
}
.api-key {
  font-family: monospace;
  background:var(--color-bg);
  padding: 2px 8px;
  border-radius: 4px;
  margin-right: 10px;
}
.api-key-item {
  margin-bottom: 10px;
  font-size: 0.9em;
  border-bottom: 1px solid var(--color-border);
}
.api-key-item .field {
  display: inline-block;
  /* margin-left: 10px; */
  margin-right: 10px;
  color: var(--color-text);
}
.api-key-item ul.details {
  display: inline-block;
  float:right;
}
.api-key-item .details li {
  display: inline-block;
}

.api-key-label {
  margin-right: 10px;
  font-weight: bold;
  color: var(--color-text);
}
.api-key-id {
  margin-right: 10px;
  font-family: monospace;

  color: var(--color-text);
}
.api-key-status {
  margin-right: 10px;
  font-weight: bold;
}
.api-key-created {
  color: var(--color-text);
}
.api-key-status-active .api-key-status {
  color: var(--color-safe);
}
.api-key-status-inactive .api-key-status {
  color: var(--color-danger);
}
.api-key-status-expired .api-key-status {
  color: var(--color-danger);
}

.api-key-expiration {
  color: var(--color-text);
}
.api-key-last-used {
  color: var(--color-text);
}
.api-key-form {
  margin-top: 30px;
}
.api-key-form input {
  padding: 8px;
  margin-right: 10px;
  border: 1px solid var(--color-border);
  border-radius: 4px;
}
.api-key-form button {
  padding: 8px 16px;
  background: var(--color-safe);
  color: var(--color-text-light);
  border: none;
  border-radius: 4px;
  cursor: pointer;
}
.error-message {
  color: var(--color-danger);
  margin-top: 10px;
}
.success-message {
  color: var(--color-safe);
  margin-top: 10px;
}
.api-keys-table {
  width: 100%;
  border-collapse: collapse;
  margin-top: 20px;
  background: var(--color-bg);
  border-radius: 8px;
  overflow: hidden;
  box-shadow: 0 2px 10px rgba(0,0,0,0.04);
}
.api-keys-table th, .api-keys-table td {
  padding: 10px 12px;
  text-align: left;
  border-bottom: 1px solid var(--color-border);
}
.api-keys-table th {
  background: var(--color-frame-bg);
  color: var(--color-text);
  font-weight: bold;
}
.api-keys-table tr:last-child td {
  border-bottom: none;
}
.api-key-label {
  font-weight: bold;
  color: var(--color-text);
}
.api-key-id {
  font-family: monospace;
  color: var(--color-text);
}
.api-key-status {
  font-weight: bold;
}
.api-key-status-active .api-key-status {
  color: var(--color-safe);
}
.api-key-status-inactive .api-key-status,
.api-key-status-expired .api-key-status {
  color: var(--color-danger);
}
.api-key-created,
.api-key-expiration,
.api-key-last-used {
  color: var(--color-text);
}
</style> 